($ => {
  const randomizeBtn = {
    init(insertElem, insertPlacement) {
      this.initGlobals();
      this.globals.$randomizeBtn.on('click', this.clickHandler.bind(this));
      insertElem.insertAdjacentElement(insertPlacement, this.globals.$randomizeBtn[0]);
    },
    globals: {},
    async initGlobals() {
      this.globals.$randomizeBtn = $('<button class="cpbc-randomize-btn cpb-actions-btn">Randomize</button>');
      this.globals.panels = CPB.getStore().getState().Product.panels;
      let api =  await CPB.FrontendApi();
      this.globals.api = new api();
    },
    getRandomInteger(min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min)) + min
    },
    async clickHandler() {
      let selections = [];
      this.globals.panels.forEach((p, i, arr) => {
        if (i == arr.length - 1) return
        const randomCatIndex = this.getRandomInteger(0, p.categories.length);
        const randomChoiceIndex = this.getRandomInteger(0, p.categories[randomCatIndex].options.length);
        let selection = {
          panel: p,
          category: p.categories[randomCatIndex],
          options: [p.categories[randomCatIndex].options[randomChoiceIndex]]
        };
        selections.push(selection);
      });

      for (let i = 0; i < selections.length; i++) {
        await this.globals.api.updateOptions(selections[i]);
        // console.log(i, selections[i].options[0].option.data.label);
      }
      this.globals.api.changeViewByIndex(1);
    }
  }

  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
    randomizeBtn.init(document.querySelector('.cpb-product-actions-container'), 'beforeend');
  })

})(jQuery)